<div class="services-page-container">
<!--  <app-background-looped-slider-->
<!--    [autoplay]="false"-->
<!--    [slideInterval]="10"-->
<!--    [slideType]="'services'"-->
<!--    [services]="AboutArray"-->
<!--  />-->
  <app-slider-horizontal [elements]="AboutArray"/>
  <div *ngFor="let service of servicesDto" style="z-index: 1">
    <app-country-info-el [location]="service" [type]="'service'"/>
  </div>
</div>
<div class="services-page-mob-container">
  <div class="services-page-mob">
    <div class="services-page-mob-title">
      <app-texts [texts]="[
        {text: ['услуги', 'services']}
      ]"/>
    </div>
    <div class="services-page-mob-els">
      <div *ngFor="let service of servicesDto">
        <app-country-info-el [location]="service" [type]="'service'"/>
      </div>
    </div>
  </div>
</div>
